import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import React, { useState } from 'react';
import { IDocumentDirectory } from '../../Interfaces/IDocumentDirectory';
import { IDocumentDirectoryHasDocument } from '../../Interfaces/IDocumentDirectoryHasDocument';
import { ILandParcelEntry } from '../../Interfaces/IRealEstate';
import { LandregisterSerach } from './LandregisterSerach';

export interface IResult {
  Landregister: string;
  SheetNumber: string;
  Marking: string;
  CadastralDistrict: string;
  CadastralUnit: string;
  Location: string;
  OrderNumber: string;
  Ges: string;
  LastName: string;
  FirstName: string;
  Birthname: string;
  Birthday: string;
}

interface IProps {
  idLegalTransaction: number;
  documentArray: IDocumentDirectoryHasDocument[];
  documentDirectoryArray: IDocumentDirectory[];
  setDocumentArray: Function;
  setDocumentDirectoryArray: Function;
  landParcelEntry?: ILandParcelEntry;
  addressSearchString?: string;
}

export const LandregisterSerachDialog: React.FC<IProps> = ({
  idLegalTransaction,
  documentArray,
  documentDirectoryArray,
  setDocumentArray,
  setDocumentDirectoryArray,
  landParcelEntry,
  addressSearchString,
}) => {
  const is_enabled_landregister =
    localStorage.getItem('is_enabled_landregister') === 'true';

  //
  const [isOpenSearch, setIsOpenSearch] = useState(false);
  //

  const hanldeCloseDialog = () => {
    setIsOpenSearch(false);
  };

  return (
    <>
      {isOpenSearch && (
        <Dialog
          open={isOpenSearch}
          onClose={hanldeCloseDialog}
          maxWidth='lg'
          fullWidth
        >
          <DialogTitle>Grundbuch</DialogTitle>
          <DialogContent>
            <LandregisterSerach
              documentArray={documentArray}
              documentDirectoryArray={documentDirectoryArray}
              idLegalTransaction={idLegalTransaction}
              setDocumentArray={setDocumentArray}
              setDocumentDirectoryArray={setDocumentDirectoryArray}
              landParcelEntry={landParcelEntry}
              addressSearchString={addressSearchString}
            />
          </DialogContent>
          <DialogActions>
            <Button variant='contained' onClick={hanldeCloseDialog}>
              Schließen
            </Button>
          </DialogActions>
        </Dialog>
      )}

      <Button
        variant='outlined'
        sx={{ float: 'right', mr: 2 }}
        onClick={() => setIsOpenSearch(true)}
        title={
          is_enabled_landregister
            ? 'Grundbuchauszug beziehen'
            : 'Sie haben keine Zugangsdaten für das Grundbuch hinterlegt. Bitte melden Sie sich ggf. bei Ihrem Administrator'
        }
        disabled={!is_enabled_landregister}
      >
        Grundbuch abfragen
      </Button>
    </>
  );
};
